import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Form, Input, Typography, Button } from "antd";
import { toastService } from "../../../../common/toast-messages/toast";
import { EyeInvisibleOutlined, EyeTwoTone } from "@ant-design/icons";
import { resetNewPassword } from "../../../../../redux/services/auth/authServices";
import RequiredLabel from "../../../../common/required-label/RequiredLabel";
import styles from "./ResetPassword.module.scss";
import { appConstConfig } from "../../../../../constants/config/appConstConfig";
const { Title } = Typography;

const ResetPassword = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);

  const onFinish = (values) => {
    if (values) {
      let resetPasswordBody = {
        password: values.password2,
      };

      if (values.password1 === values.password2) {
        dispatch(resetNewPassword(resetPasswordBody, navigate, setLoading));
      } else {
        toastService.error(t("ResetPassword.confirmPasswordText"));
      }
    }
  };

  return (
    <>
      <div className={styles.mainContainer}>
        <Title level={1} className={styles.titleStyle}>
          {t("ResetPassword.title")}
        </Title>
        <Title level={4} type="secondary" className={styles.subTitleStyle}>
          {t("ResetPassword.subTitle")}
        </Title>
        <Form
          layout="vertical"
          onFinish={onFinish}
          autoComplete="off"
          requiredMark={false}
        >
          <div style={{ height: "270px" }}>
            <Form.Item
              label={
                <RequiredLabel
                  text={t("ResetPassword.newPasswordLabel")}
                  required={true}
                />
              }
              name="password1"
              className={styles.labelTextStyle}
              rules={[
                {
                  required: true,
                  message: t("ResetPassword.newPasswordErrorMessage")
                },
                {
                  pattern: appConstConfig.PASSWORD_VALIDATION_REGEX,
                  message: t("CommonUtils.invalidPassword")
                }
              ]}
            >
              <Input.Password
                placeholder={t("ResetPassword.newPasswordPlaceholder")}
                iconRender={(visible) =>
                  visible ? <EyeTwoTone style={{fontSize:16}}/> : <EyeInvisibleOutlined style={{fontSize:16}}/>
                }
              />
            </Form.Item>

            <Form.Item
              label={
                <RequiredLabel
                  text={t("ResetPassword.confirmPasswordLabel")}
                  required={true}
                />
              }
              name="password2"
              className={styles.labelTextStyle}
              rules={[
                {
                  required: true,
                  message: t("ResetPassword.confirmPasswordErrorMessage"),
                },
              ]}
            >
              <Input.Password
                placeholder={t("ResetPassword.confirmPasswordPlaceholder")}
                iconRender={(visible) =>
                  visible ? <EyeTwoTone style={{fontSize:16}}/> : <EyeInvisibleOutlined style={{fontSize:16}}/>
                }
              />
            </Form.Item>
          </div>

          <div>
            <Button
              type="primary"
              className={styles.buttonStyle}
              htmlType="submit"
              loading={loading}
            >
              {t("ResetPassword.confirm")}
            </Button>
          </div>
        </Form>
      </div>
    </>
  );
};

export default ResetPassword;
